<div class="container-fluid customers-root">
  <div class="stats-root">
    <div class="stats-item" [ngClass]="{ active: showBuildings }" (click)="showBuildings = true; showDts = false">
      <div>{{ 'SIDENAV.BUILDINGS' | translate }}</div>
    </div>

    <div class="stats-item" [ngClass]="{ active: showDts }" (click)="showBuildings = false; showDts = true">
      <div>{{ 'SIDENAV.TRANSFORMERS'| translate }}</div>
    </div>
  </div>
</div>

<app-transformers *ngIf="showDts">  </app-transformers>
<app-buildings *ngIf="showBuildings">  </app-buildings>
